import CustomerOrder from './customer-order';
import { BaseEntity, JsonApiRelationship, JsonApiResource } from '../jsonapi-provider';

import type SiteMenuOrder from './site-menu-order';

@JsonApiResource({
  type: 'customer-order-revision',
})
export default class CustomerOrderRevision extends BaseEntity {
  revisionNumber: number = 1;
  siteNames?: string;
  siteNamesWithDisplayNumber?: string;
  @JsonApiRelationship('customer-order') customerOrder = new CustomerOrder();
  @JsonApiRelationship('site-menu-order') siteMenuOrders: SiteMenuOrder[] = [];
}
